<template>
	<div id="app">
		<div class="font-sans antialiased h-screen" v-if="isAuthenticated && user">
			<!-- Top Navigation -->
			<header class="fixed z-50 h-16 w-full bg-grey-darker shadow flex items-center justify-between">
				<div class="flex items-center h-full">
					<div class="flex items-center text-center h-full w-48 border-r border-grey-dark">
						<span class="w-full text-white text-sm uppercase font-extrabold">Utskriftsappen</span>
					</div>
				</div>
				<div class="flex items-center h-full text-sm">
					<div class="flex items-center h-full">

						<!-- <a href="#" class="flex items-center text-white h-full px-4">Support</a> -->

						<div class="group relative h-full">
							<a href="#" class="text-white flex items-center h-full bg-grey-darkest px-4">
								{{ userName }}
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current ml-1"><path class="heroicon-ui" d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"/></svg>
							</a>
							<div class="hidden group-hover:block absolute pin-r top-full w-48 bg-black">
								<a href="/logout" class="block text-left py-4 px-3 text-white hover:text-blue-dark text-sm" @click.prevent="logout()">
									Logga ut
								</a>
							</div>
						</div>
					</div>
				</div>
			</header>
			
			<div id="main" class="pt-16">

				<!-- Sidebar -->
				<div class="fixed z-20 bg-grey-darkest h-full w-48">
					<div class="xl:py-2">
						<div class="hidden xl:block uppercase font-bold text-grey-darker text-xs px-4 py-2">
							Gå till
						</div>

						<div class="group relative sidebar-item with-children">
							<router-link to="/" class="block xl:flex xl:items-center text-center xl:text-left shadow-light xl:shadow-none py-6 xl:py-2 xl:px-4 border-l-4 border-transparent hover:bg-black">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current xl:mr-2"><path class="heroicon-ui" d="M13 20v-5h-2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.59l-.3.3a1 1 0 1 1-1.4-1.42l9-9a1 1 0 0 1 1.4 0l9 9a1 1 0 0 1-1.4 1.42l-.3-.3V20a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm5 0v-9.59l-6-6-6 6V20h3v-5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v5h3z"/></svg>
								<div class="text-white text-sm">
									Visa utskrift
								</div>
							</router-link>
							<router-link v-if="user && $hasPermission(user, 'can_manage_interpolation_settings')" to="/settings" class="block xl:flex xl:items-center text-center xl:text-left shadow-light xl:shadow-none py-6 xl:py-2 xl:px-4 border-l-4 border-transparent hover:bg-black">
								<svg class="h-6 w-6 xl:mr-2 text-grey-darker fill-current" viewBox="0 0 24 24"><path d="M24 14.187v-4.374c-2.148-.766-2.726-.802-3.027-1.529-.303-.729.083-1.169 1.059-3.223l-3.093-3.093c-2.026.963-2.488 1.364-3.224 1.059-.727-.302-.768-.889-1.527-3.027h-6.376c-.764 2.144-.8 2.725-1.529 3.027-.752.313-1.203-.1-3.223-1.059l-3.093 3.093c.977 2.055 1.362 2.493 1.059 3.224-.302.727-.881.764-3.027 1.528v4.375c2.139.76 2.725.8 3.027 1.528.304.734-.081 1.167-1.059 3.223l3.093 3.093c1.999-.95 2.47-1.373 3.223-1.059.728.302.764.88 1.529 3.027h4.374c.758-2.131.799-2.723 1.537-3.031.745-.308 1.186.099 3.215 1.062l3.093-3.093c-.975-2.05-1.362-2.492-1.059-3.223.3-.726.88-.763 3.027-1.528zm-4.875.764c-.577 1.394-.068 2.458.488 3.578l-1.084 1.084c-1.093-.543-2.161-1.076-3.573-.49-1.396.581-1.79 1.693-2.188 2.877h-1.534c-.398-1.185-.791-2.297-2.183-2.875-1.419-.588-2.507-.045-3.579.488l-1.083-1.084c.557-1.118 1.066-2.18.487-3.58-.579-1.391-1.691-1.784-2.876-2.182v-1.533c1.185-.398 2.297-.791 2.875-2.184.578-1.394.068-2.459-.488-3.579l1.084-1.084c1.082.538 2.162 1.077 3.58.488 1.392-.577 1.785-1.69 2.183-2.875h1.534c.398 1.185.792 2.297 2.184 2.875 1.419.588 2.506.045 3.579-.488l1.084 1.084c-.556 1.121-1.065 2.187-.488 3.58.577 1.391 1.689 1.784 2.875 2.183v1.534c-1.188.398-2.302.791-2.877 2.183zm-7.125-5.951c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z"/></svg>
								<div class="text-white text-sm">
									Inställningar
								</div>
							</router-link>
						</div>
					</div>
					<div class="xl:py-2" v-if="$route.name === 'PrintLayout'">
						<div class="hidden xl:block uppercase font-bold text-grey-darker text-xs px-4 py-2">
							Alternativ
						</div>

						<button @click="changeType()" class="block xl:flex xl:items-center text-center xl:text-left shadow-light xl:shadow-none py-6 xl:py-2 xl:px-4 border-l-4 border-transparent hover:bg-black">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current xl:mr-2"><path class="heroicon-ui" d="M9 4.58V4c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v.58a8 8 0 0 1 1.92 1.11l.5-.29a2 2 0 0 1 2.74.73l1 1.74a2 2 0 0 1-.73 2.73l-.5.29a8.06 8.06 0 0 1 0 2.22l.5.3a2 2 0 0 1 .73 2.72l-1 1.74a2 2 0 0 1-2.73.73l-.5-.3A8 8 0 0 1 15 19.43V20a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-.58a8 8 0 0 1-1.92-1.11l-.5.29a2 2 0 0 1-2.74-.73l-1-1.74a2 2 0 0 1 .73-2.73l.5-.29a8.06 8.06 0 0 1 0-2.22l-.5-.3a2 2 0 0 1-.73-2.72l1-1.74a2 2 0 0 1 2.73-.73l.5.3A8 8 0 0 1 9 4.57zM7.88 7.64l-.54.51-1.77-1.02-1 1.74 1.76 1.01-.17.73a6.02 6.02 0 0 0 0 2.78l.17.73-1.76 1.01 1 1.74 1.77-1.02.54.51a6 6 0 0 0 2.4 1.4l.72.2V20h2v-2.04l.71-.2a6 6 0 0 0 2.41-1.4l.54-.51 1.77 1.02 1-1.74-1.76-1.01.17-.73a6.02 6.02 0 0 0 0-2.78l-.17-.73 1.76-1.01-1-1.74-1.77 1.02-.54-.51a6 6 0 0 0-2.4-1.4l-.72-.2V4h-2v2.04l-.71.2a6 6 0 0 0-2.41 1.4zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/></svg>								
							<div class="text-white text-sm">
								Välj visad analys
							</div>
						</button>

						<button @click="addBackgroundMap()" class="block xl:flex xl:items-center text-center xl:text-left shadow-light xl:shadow-none py-6 xl:py-2 xl:px-4 border-l-4 border-transparent hover:bg-black">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 text-grey-darker fill-current xl:mr-2"><path d="M24 14.378l-5.641 5.64c-.654.655-1.513.982-2.374.982-2.972 0-4.493-3.613-2.374-5.731l5.539-5.54c.488-.486 1.126-.729 1.766-.729 1.494 0 2.498 1.233 2.498 2.519 0 .61-.227 1.232-.734 1.74l-4.918 4.918c-.634.634-1.665.634-2.299 0-.633-.633-.633-1.664 0-2.298l3.971-3.97.828.828-3.971 3.97c-.178.177-.178.466 0 .643s.465.177.643 0l4.919-4.918c.517-.517.517-1.357 0-1.874-.517-.517-1.356-.517-1.874 0l-5.539 5.54c-.854.853-.854 2.241 0 3.093.852.853 2.24.853 3.093 0l5.64-5.64.827.827zm-17-5.878c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5c0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5zm7.57 3.013l-1.57-2.513-2.52 4-2.48-1.96-4 5.96h6.694c.144-1.139.63-2.242 1.503-3.114l2.373-2.373zm-3.754 7.487h-8.816v-14h18v2.126c.299-.062.604-.096.916-.096.371 0 .732.06 1.084.147v-4.177h-22v18h11.818c-.482-.605-.818-1.283-1.002-2z"/></svg>						
							<div class="text-white text-sm">
								Bakgrundskarta
							</div>
						</button>
					</div>

					<div class="xl:py-2" v-if="$route.name === 'PrintLayout'">
						<div class="hidden xl:block uppercase font-bold text-grey-darker text-xs px-4 py-2">
							Åtgärder
						</div>

						<div class="px-3 mt-2">
							<button @click="addPage()" class="flex items-center justify-center py-1 my-2 w-full text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 mr-1 fill-current"><path class="heroicon-ui" d="M6 2h9a1 1 0 0 1 .7.3l4 4a1 1 0 0 1 .3.7v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm9 2.41V7h2.59L15 4.41zM18 9h-3a2 2 0 0 1-2-2V4H6v16h12V9z"/></svg>
								<p class="w-3/5">Lägg till sida</p>
							</button>

							<button @click="openTemplateModal()" class="flex items-center justify-center py-1 my-2 w-full text-sm text-center text-white block bg-orange-dark hover:bg-orange rounded shadow-light font-bold">
								<svg class="h-6 w-6 mr-1 text-white fill-current" viewBox="-61 0 512 512">
									<path d="M 301.222656 0 L 0 0 L 0 512 L 390.015625 512 L 390.015625 88.792969 Z M 30 482 L 30 30 L 280.253906 30 L 280.265625 109.75 L 360.015625 109.761719 L 360.015625 482 Z M 310.257812 51.460938 L 338.554688 79.757812 L 310.261719 79.753906 Z M 310.257812 51.460938 " /><path d="M 61.992188 353.667969 L 324.011719 353.667969 L 324.011719 383.667969 L 61.992188 383.667969 Z M 61.992188 353.667969" /><path d="M 61.992188 413.671875 L 321.476562 413.671875 L 321.476562 443.671875 L 61.992188 443.671875 Z M 61.992188 413.671875" /><path d="M 323.816406 149.648438 L 62.515625 149.648438 L 62.515625 323.988281 L 323.816406 323.988281 Z M 164.832031 236.816406 L 92.511719 281.945312 L 92.511719 191.691406 Z M 129.886719 179.648438 L 256.445312 179.648438 L 193.164062 219.136719 Z M 193.164062 254.5 L 256.445312 293.988281 L 129.886719 293.988281 Z M 221.5 236.816406 L 293.816406 191.6875 L 293.816406 281.945312 Z M 221.5 236.816406" />
								</svg>
								<p class="w-3/5">Mallar</p>
							</button>

							<!-- This button will only be visible if region is Halland -->
							<button @click="displayExtraValuesModal()" class="flex items-center justify-center py-1 my-2 w-full text-sm text-center text-white block bg-teal hover:bg-teal-dark rounded shadow-light font-bold" v-if="user && user.region.id === 2">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 mr-1 fill-current"><path d="M12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5h-13c-1.93 0-3.5-1.57-3.5-3.5 0-2.797 2.479-3.833 4.433-3.72-.167-4.218 2.208-6.78 5.567-6.78zm0-2c-4.006 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408-.212-3.951-3.473-7.092-7.479-7.092zm4 10h-3v4h-2v-4h-3l4-4 4 4z"/></svg>
								<p class="w-3/5">Lägg till extra värde</p>
							</button>

							<button @click="openPrintModal()" class="flex items-center justify-center py-1 my-2 w-full text-sm text-center text-white block bg-blue hover:bg-blue-dark rounded shadow-light font-bold ">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-6 w-6 mr-1 fill-current"><path class="heroicon-ui" d="M18 18v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2H4a2 2 0 0 1-2-2v-6c0-1.1.9-2 2-2h2V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2zm0-2h2v-6H4v6h2v-2c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2zm-2-8V4H8v4h8zm-8 6v6h8v-6H8z"/></svg>
								
								<p class="w-3/5">Skapa PDF</p>
							</button>
						</div>
					</div>
				</div>
				
				<!-- Content -->
				<div class="bg-grey h-minus-header ml-48">
					<div class="text-center w-full text-grey-darkest ">
						<router-view :key="$route.fullPath"></router-view>
					</div>
				</div>

			</div>
		</div>

		<div v-else>
			<router-view></router-view>
		</div>
		
		<Notification></Notification>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'
import Notification from '@/components/Notification.vue'

export default {

	components: {
		Notification
	},

	mounted() {
		this.$store.dispatch('settings/GET_SETTINGS_FROM_LOCAL_STORAGE')
	},

	computed: {
		...mapGetters({
			currentTemplate:	'template/defaultTemplate',
			isAuthenticated:	'auth/isAuthenticated',
			userName:			'auth/userName',
			user:				'auth/user',
		}),
	},

    methods: {
        logout() {
			this.$store.dispatch("auth/AUTH_LOGOUT")
			this.$router.push({name: 'login'})
		},

		addPage() {
			if(this.currentTemplate) {
				this.$store.dispatch("layout/ADD_NEW_PAGE_FROM_TEMPLATE", JSON.parse(this.currentTemplate.json));
			} else {
				this.$store.dispatch("layout/ADD_NEW_PAGE");
			}
		},

		changeType() {
			bus.$emit('open-global-settings-modal')
		},

		openTemplateModal() {
			bus.$emit('open-template-modal')
		},

		openPrintModal() {
			bus.$emit('open-print-modal')
		},

		addBackgroundMap() {
        	bus.$emit('open-add-background-map-modal')
		},

		displayExtraValuesModal() {
        	bus.$emit('open-add-extra-analysis-modal')
		}
    },

}
</script>

<style>
	.h-minus-header {
		min-height: calc(100vh - 4rem);
	}
</style>